import { PrintBasicInfoTableLayout } from "../../../layout";

type Props = {
	guestEmail: string;
};

export const BasicInfoGuestEmailOfPrintComposition = ({ guestEmail }: Props) => {
	return <PrintBasicInfoTableLayout title="Eメール" content={guestEmail} />;
};
